import { useRef, type MutableRefObject } from 'react';
import { createLiveTransport, type LiveTransportAdapter, type LiveTransportInput } from './transport';
import { TranscriptStore } from './transcriptStore';

export const useLiveSession = (input: LiveTransportInput): {
  transport: LiveTransportAdapter;
  transcriptStoreRef: MutableRefObject<TranscriptStore>;
} => {
  const transport = createLiveTransport(input);
  const transcriptStoreRef = useRef(new TranscriptStore());
  return { transport, transcriptStoreRef };
};
